<template>
    <div id="mySidenavLegenda" class="sidenav p-0" style="background-color: #ffffff;">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #15B9D9 !important;color: #ffffff;">
                <h3 class="card-title text-white">Legenda</h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavLegenda()">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="card-body" style="color: #111 !important;min-height: 100vh;">
                <h6><b id="legendalayer" class="text-black">Legenda Layer Peta</b></h6>
                <ul id="treelegenda" style="cursor: pointer;font-size: small !important;" class="text-black">
                </ul>
            </div>
            <!-- /.card-header -->
        </div>
    </div>
    <div id="mySidenavPengaturan" class="sidenav p-0" style="background-color: #ffffff;">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #15B9D9 !important;color: #ffffff;">
                <h3 class="card-title text-white">Base Map</h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavPengaturan()">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="card-body text-black" style="min-height: 100vh;">
                <h6 class="text-black"><b id="pengeturan">Pengaturan Base Map</b></h6>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio111"
                        name="customRadio" value="1" @click="tampilbasemap('customRadio111')">
                    <label for="customRadio111" class="custom-control-label">Google Map (ROADMAP)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio6"
                        name="customRadio" value="6" @click="tampilbasemap('customRadio6')">
                    <label for="customRadio6" class="custom-control-label">Google Map (Hybrid)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio8"
                        name="customRadio" value="8" @click="tampilbasemap('customRadio8')">
                    <label for="customRadio8" class="custom-control-label">Google Map (Terrain)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio22"
                        name="customRadio" value="2" @click="tampilbasemap('customRadio22')" checked="checked">
                    <label for="customRadio22" class="custom-control-label">MapQuest OSM</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio4"
                        name="customRadio" value="4" @click="tampilbasemap('customRadio4')">
                    <label for="customRadio4" class="custom-control-label">Esri World Topo Map</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio9"
                        name="customRadio" value="9" @click="tampilbasemap('customRadio9')">
                    <label for="customRadio9" class="custom-control-label">ESRI World Imagery</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio10"
                        name="customRadio" value="10" @click="tampilbasemap('customRadio10')">
                    <label for="customRadio10" class="custom-control-label">ESRI World Street Map</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio11"
                        name="customRadio" value="11" @click="tampilbasemap('customRadio11')">
                    <label for="customRadio11" class="custom-control-label">ESRI Gray Map</label>
                </div>
            </div>
            <!-- /.card-header -->
        </div>
    </div>
    <div id="mySidenavLayer" class="sidenav p-0">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #15B9D9 !important;color: #ffffff;">
                <h3 class="card-title text-white">Layer</h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavLayer()"><i
                            class="fa fa-times"></i></button>
                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body" style="color: #4e5256 !important;min-height: 100vh;">
                <h6><b id="judultransparant" class="text-black">Transparansi Layer</b></h6>
                <input id="opacity-input" type="range" min="0" max="1" step="0.01" value="0.75" style="width: 100%;"
                    class="accent" /><span id="opacity-output" style="display: none;"></span>
                <h6><b id="pilihandaftarlayer" class="text-black">Pilihan Lokasi</b></h6>
                <div class="col-sm-12">
                    <v-select multiple :options="kabkot" :reduce="(label) => label.code" label="label"
                        v-model="defaultSelectedkabkot" @option:selected="onkabkotChangeSelect($event)"
                        @option:deselected="onkabkotChangeDeselect($event)"
                        style="background-color: #ffffff;padding-bottom: 10px;font-size: small;"></v-select>
                </div>
                <h6><b id="daftarlayer" class="text-black">Daftar Layer</b></h6>
                <div class="col-sm-12 float-left pb-2">
                    <div class="input-group mb-3">
                        <input id="carikata" v-model="carikata" placeholder="Masukkan Kata Kunci Pencarian Layer"
                            type="text" class="form-control form-control-sm" style="font-size: small !important;"
                            @change="ambildata()">
                        <div class="input-group-append">
                            <span class="input-group-text" @click="ambildata()" style="cursor: pointer;"><i
                                    class="fas fa-search"></i></span>
                        </div>
                    </div>
                </div>
                <ul id="tree1" style="cursor: pointer;font-size: small !important;">
                </ul>
            </div>
        </div>
    </div>
    <div id="myInfoLayer" class="sidenavkanan p-0">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #15B9D9 !important;color: #ffffff;">
                <h3 class="card-title text-white">Info</h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavInfo()"><i
                            class="fa fa-times"></i></button>
                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body text-center" id="exceldata">
                <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                    data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel1('_Keterangan_')">
                    <i class="fas fa-download"></i>
                    Unduh Keterangan .xlsx
                </button>
            </div>
            <div class="card-body" style="color: black !important;min-height: 95vh;width: 90%; overflow: auto;"
                id="Info_Adit">
            </div>
        </div>
    </div>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center" style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModalalokasi" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Daftar Alokasi / Riwayat Penanganan</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify">
                    <div class="col-sm-12">
                        <div class="card cardputih collapsed-card">
                            <div class="card-header border-transparent" data-card-widget="collapse"
                                style="cursor: pointer;">
                                <label>
                                    <span>Filter Data</span>
                                </label>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body px-3">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label>Anggaran</label>
                                        <v-select :options="anggaran" :reduce="(label) => label.code" label="label"
                                            v-model="defaultSelectedanggaran" @update:modelValue="onanggaranChange"
                                            style="background-color: #ffffff;"></v-select>
                                    </div>
                                    <div class="col-sm-12">&nbsp;</div>
                                    <div class="col-sm-12">
                                        <label>Jenis Bantuan Keuangan</label>
                                        <v-select :options="jenisbantuan" :reduce="(label) => label.code" label="label"
                                            v-model="defaultSelectedjenisbantuan"
                                            @update:modelValue="onjenisbantuanChange"
                                            style="background-color: #ffffff;"></v-select>
                                    </div>
                                    <div class="col-sm-12">&nbsp;</div>
                                    <div class="col-sm-12">
                                        <label>Bidang Bantuan Keuangan</label>
                                        <v-select :options="bidangbantuan" :reduce="(label) => label.code" label="label"
                                            v-model="defaultSelectedbidangbantuan"
                                            @update:modelValue="onbidangbantuanChange"
                                            style="background-color: #ffffff;"></v-select>
                                    </div>
                                    <div class="col-sm-12">&nbsp;</div>
                                    <div class="col-sm-12">
                                        <label>Sub Bidang Bantuan Keuangan</label>
                                        <v-select :options="subbidangbantuan" :reduce="(label) => label.code"
                                            label="label" v-model="defaultSelectedsubbidangbantuan"
                                            @update:modelValue="onsubbidangbantuanChange"
                                            style="background-color: #ffffff;"></v-select>
                                    </div>
                                    <div class="col-sm-12">&nbsp;</div>
                                    <div class="col-sm-12 text-center">
                                        <button type="button" class="btn btn-success3 btn-sm text-white lebar2"
                                            @click="ambildataalokasi(selectedkabkotalokasi)" data-toggle="tooltip"
                                            data-placement="left" title="Terapkan Filter..">
                                            <i class="fas fa-search"></i> Terapkan Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 text-center py-2">
                        <a class="hitam">
                            <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                                data-placement="left" title="Unduh excel.."
                                @click="G_tableCSVTabel3('_DaftarRiwayatPenangananRekapKota_')">
                                <i class="fas fa-download"></i>
                                <span>
                                    Unduh Data .xlsx
                                </span>
                            </button>
                        </a>
                    </div>
                    <div class="col-sm-12">
                        <div class="table-responsive table-wrapper" v-if="selectedkabkotalokasi.length == 4">
                            <table class="table m-0" id="tabeldataalokasi" style="font-size: small;">
                                <thead>
                                    <tr>
                                        <th style="width: 50px;">No</th>
                                        <th style="width: 150px;">Kabupaten / Kota</th>
                                        <th style="width: 50px;">Tahun</th>
                                        <th style="width: 100px;">Jenis Bantuan</th>
                                        <th style="width: 100px;">Bidang</th>
                                        <th style="width: 100px;">Sub Bidang</th>
                                        <th style="width: 150px;">Kegiatan</th>
                                        <th style="width: 80px;">Jumlah Alokasi Anggaran (Rp.)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="total" colspan="7">TOTAL</td>
                                        <td class="totalkanan" data-z="#,##0.00" :data-v="totalalokasi">{{
                                            G_numFormatKoma(totalalokasi) }}
                                        </td>
                                    </tr>
                                    <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                        <tr>
                                            <td class="text-center">
                                                {{ (urutlist + 1) }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.NAMAKABKOT }}
                                            </td>
                                            <td class="text-center">
                                                {{ datalist.Tahun }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.JenisBantuan }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Bidang }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.SubBidang }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Kegiatan }}
                                            </td>
                                            <td class="text-right" data-z="#,##0.00" :data-v="datalist.Alokasi">
                                                {{ G_numFormatKoma(datalist.Alokasi) }}
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive table-wrapper" v-if="selectedkabkotalokasi.length == 6">
                            <table class="table m-0" id="tabeldataalokasi" style="font-size: small;">
                                <thead>
                                    <tr>
                                        <th style="width: 50px;">No</th>
                                        <th style="width: 150px;">Kabupaten / Kota</th>
                                        <th style="width: 150px;">Kecamatan</th>
                                        <th style="width: 50px;">Tahun</th>
                                        <th style="width: 100px;">Jenis Bantuan</th>
                                        <th style="width: 100px;">Bidang</th>
                                        <th style="width: 100px;">Sub Bidang</th>
                                        <th style="width: 150px;">Kegiatan</th>
                                        <th style="width: 80px;">Jumlah Alokasi Anggaran (Rp.)</th>
                                        <th style="width: 50px;">Volume</th>
                                        <th style="width: 50px;">Satuan</th>
                                        <th style="width: 100px;">Keluaran</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="total" colspan="7">TOTAL</td>
                                        <td class="totalkanan" data-z="#,##0.00" :data-v="totalalokasi">{{
                                            G_numFormatKoma(totalalokasi) }}
                                        </td>
                                        <td class="total" colspan="3"></td>
                                    </tr>
                                    <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                        <tr>
                                            <td class="text-center">
                                                {{ (urutlist + 1) }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.NAMAKABKOT }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.NAMAKECAMATAN }}
                                            </td>
                                            <td class="text-center">
                                                {{ datalist.Tahun }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.JenisBantuan }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Bidang }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.SubBidang }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Kegiatan }}
                                            </td>
                                            <td class="text-right" data-z="#,##0.00" :data-v="datalist.Alokasi">
                                                {{ G_numFormatKoma(datalist.Alokasi) }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Volume }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Satuan }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Keluaran }}
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive table-wrapper" v-if="selectedkabkotalokasi.length == 10">
                            <table class="table m-0" id="tabeldataalokasi" style="font-size: small;">
                                <thead>
                                    <tr>
                                        <th style="width: 50px;">No</th>
                                        <th style="width: 150px;">Kabupaten / Kota</th>
                                        <th style="width: 150px;">Kecamatan</th>
                                        <th style="width: 150px;">Desa</th>
                                        <th style="width: 50px;">Tahun</th>
                                        <th style="width: 100px;">Jenis Bantuan</th>
                                        <th style="width: 100px;">Bidang</th>
                                        <th style="width: 100px;">Sub Bidang</th>
                                        <th style="width: 150px;">Kegiatan</th>
                                        <th style="width: 80px;">Jumlah Alokasi Anggaran (Rp.)</th>
                                        <th style="width: 50px;">Volume</th>
                                        <th style="width: 50px;">Satuan</th>
                                        <th style="width: 100px;">Keluaran</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="total" colspan="7">TOTAL</td>
                                        <td class="totalkanan" data-z="#,##0.00" :data-v="totalalokasi">{{
                                            G_numFormatKoma(totalalokasi) }}
                                        </td>
                                        <td class="total" colspan="5"></td>
                                    </tr>
                                    <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                        <tr>
                                            <td class="text-center">
                                                {{ (urutlist + 1) }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.NAMAKABKOT }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.NAMAKECAMATAN }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.NAMADESA }}
                                            </td>
                                            <td class="text-center">
                                                {{ datalist.Tahun }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.JenisBantuan }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Bidang }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.SubBidang }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Kegiatan }}
                                            </td>
                                            <td class="text-right" data-z="#,##0.00" :data-v="datalist.Alokasi">
                                                {{ G_numFormatKoma(datalist.Alokasi) }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Volume }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Satuan }}
                                            </td>
                                            <td class="text-justify">
                                                {{ datalist.Keluaran }}
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Tutup" data-toggle="tooltip"
                        data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalalokasi()">
                        <b>
                            Tutup
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModalunduhdata" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Daftar Layer</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify">
                    <div class="col-sm-12">
                        <div class="card cardputih">
                            <div class="card-body p-2">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadi" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 250px;">Nama Data Layer</th>
                                                <th style="width: 100px;">Opsi</th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in daftarunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify">
                                                        {{ datalist.nama }}
                                                    </td>
                                                    <td class="text-center">
                                                        <button type="button"
                                                            class="btn btn-success btn-sm lebar2 text-white"
                                                            @click="prosesdata(datalist.namalayer)"
                                                            data-toggle="tooltip" data-placement="left"
                                                            title="Lihat data.."><i class="fas fa-download"></i> Lihat
                                                            data</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" v-if="(dataunduhlayer.length > 0)">
                        <div class="card cardputih">
                            <div class="card-body p-2 text-center">
                                <button type="button" class="btn btn-success btn-sm lebar2 text-white"
                                    @click="G_tableCSVTabel2('_DetailData_')" data-toggle="tooltip"
                                    data-placement="left" title="Unduh data (.xlsx).."><i class="far fa-file-excel"></i>
                                    Unduh data
                                    (.xlsx)</button><br><br>
                                <span v-show="dataunduhlayer.length == 0">Silahkan Pilih Data .....</span>
                                <center>
                                    <div class="spinner-border text-danger text-center"
                                        style="width: 3rem; height: 3rem;" role="status"
                                        v-show="dataunduhlayer.length == 0">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-show="dataunduhlayer.length == 0">Loading Data .....</span>
                                </center>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadidata" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <template v-for="(datajudul, urutjudul) in datajudulunduhlayer"
                                                    :key="urutjudul">
                                                    <th style="width: 150px;">{{ datajudul }}</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in dataunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify" v-for="(dataisi, urutisi) in datalist"
                                                        :key="urutisi">
                                                        {{ dataisi.data }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Tutup" data-toggle="tooltip"
                        data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodal()">
                        <b>
                            Tutup
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModaldisclaimer" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Penjelasan dan Ketentuan</h4>
                </div>
                <div class="modal-body text-justify">
                    <p style="font-size: smaller;">
                        <b>SIMFAST JATENG</b> (Sistem Manajemen Infrastruktur Terpadu Jawa Tengah)
                        yang selanjutnya dioptimalkan sebagai "<b>Strategi Mensinergikan Fokus dan Arah Kebijakan
                        Perencanaan Berbasis Data Spasial Terpadu di Jawa Tengah</b>" merupakan sistem manajemen (alat
                        kerja) yang mengintegrasikan analisa data dan informasi infrastruktur (terkait Urusan PUPR,
                        Perhubungan, Prakim, LHK, ESDM, Kominfo) secara terpadu dengan sektor lain (ekonomi dan sosial)
                        untuk menghasilkan prioritas rencana penanganan infrastruktur di Jawa Tengah yang paling efektif
                        dan efisien dalam mewujudkan tujuan pembangunan di Provinsi Jawa Tengah.
                    </p>
                    <p class="text-center">
                    <div class="row">
                        <div class="col-sm-12 float-left">
                            <label style="font-size: smaller;" class="text-success">Silahkan Mengisi Daftar
                                Pengunjung</label>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-address-card"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama" name="nama"
                                    placeholder="Nama" v-model="nama">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-phone-square"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="hp" name="hp"
                                    placeholder="Nomor Telepon" v-model="hp" @keypress="onlyNumberKey(event)"
                                    @keydown="onlyNumberKey(event)">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="keperluan" name="keperluan"
                                    placeholder="Keperluan" v-model="keperluan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capcha" name="capcha"
                                    placeholder="Kode Keamanan" v-model="capcha" disabled @click.right.prevent
                                    @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Ulangi Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-clone"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capchainput"
                                    name="capchainput" v-model="capchainput" style="text-transform:uppercase"
                                    @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                    </div>
                    <input type="checkbox" id="customSwitchAuth" @click="rubahisi()">
                    <label style="font-size: small;" for="customSwitchAuth">
                        &nbsp;Saya mengerti dan menyetujui penjelasan dan ketentuan diatas.
                    </label>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Setuju dan lanjutkan"
                        data-toggle="tooltip" data-placement="left" title="Setuju dan lanjutkan.." style="color: black;"
                        :disabled="showHuman == false" @click="setuju()">
                        <b>
                            Setuju dan lanjutkan
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                PETA SIG IT
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        Beranda
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    Sistem Informasi Geografis Infrastruktur Terpadu
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <div class="container-fluid py-1 wow fadeInUp" data-wow-delay="0.1s">
    </div>
    <div class="col-sm-12 wow fadeInDown">
        <div class="card cardputih">
            <div class="card-header border-transparent">
                <h5 class="card-title text-black"><b>Opsi Peta</b></h5>
                <input type="hidden" id="detaildatamulti" value="">
                <input type="hidden" id="paramlayerunduh" value="">
                <input type="hidden" id="paramkodecekbox" value="">
                <input type="hidden" id="isidatakosong" value="">
                <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                    title="Parse Data" @click="parsedatalayer()" id="tombolparamunduh" style="display: none;">
                    <i class="far fa-clone"></i> Parse Data
                </button>
                <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                    title="Tes Peta" @click="ceklayer()" id="tombolparamkodecekbox" style="display: none;">
                    <i class="far fa-clone"></i> Tes Peta
                </button>
                <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                    title="Tes Peta" @click="modalfilter()" id="tombolfilterkodecekbox" style="display: none;">
                    <i class="far fa-clone"></i> Filter Peta
                </button>
                <button type="button" class="btn btn-tool text-white" data-toggle="tooltip" data-placement="left"
                    title="Data Kosong" @click="datakosonglayer()" id="tomboldatakosong" style="display: none;">
                    <i class="far fa-clone"></i> Data Kosong
                </button>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Layer Peta" @click="openNavLayer()">
                        <i class="far fa-clone"></i> Layer Peta
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Cetak Peta" @click="cekdataterpilih()">
                        <i class="fas fa-cloud-download-alt"></i> Unduh Data Tabel Peta
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Pengaturan Peta" @click="openNavPengaturan()">
                        <i class="fas fa-cogs"></i> Basemap Peta
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Legenda Peta" @click="openNavLegenda()">
                        <i class="fas fa-align-justify"></i> Legenda Peta
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Cetak Peta" @click="cetakpeta()">
                        <i class="fas fa-print"></i> Cetak Peta
                    </button>
                </div>
            </div>
        </div>
    </div>
    <button type="button" id="bukabawah" style="display: none;" class="btn btn-tool text-white" data-toggle="tooltip"
        data-placement="left" title="Buka Bawah" @click="openNavInfoBawah()">
        <i class="fas fa-cogs"></i>
    </button>
    <button type="button" id="bukabawahkec" style="display: none;" class="btn btn-tool text-white" data-toggle="tooltip"
        data-placement="left" title="Buka Bawah" @click="openNavInfoBawahKec()">
        <i class="fas fa-cogs"></i>
    </button>
    <button type="button" id="bukabawahdesa" style="display: none;" class="btn btn-tool text-white"
        data-toggle="tooltip" data-placement="left" title="Buka Bawah" @click="openNavInfoBawahDesa()">
        <i class="fas fa-cogs"></i>
    </button>
    <iframe :src="sourcenya" class="container-fluid wow fadeInUp" style="min-height: 100vh;" frameborder="0" id="maps"
        scrolling="no" @load="loadpeta()">
    </iframe>
    <!-- Header End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import select2 from 'select2';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import xlsx from 'xlsx/dist/xlsx.full.min';
import CryptoJS from 'crypto-js';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Top, Footer, swal, BarChartKerjasama: VueApexCharts, vSelect
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            carikataalokasi: '',
            showHuman: false,
            tahun: new Date().getFullYear(),
            linknya: process.env.VUE_APP_URL_API,
            sourcenya: '',
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            ipnya: '',
            capcha: this.makeid(5), capchainput: "",
            nama: '',
            hp: '',
            keperluan: '',
            tampilmodal: localStorage.getItem("bookstamu"),
            data_layer: [],
            data_legenda: [],
            kabkot: [],
            datakabkot: [],
            defaultSelectedkabkot: {
                code: 0,
                label: 'Semua Kabupaten/Kota',
                tag: '33',
            },
            selectedkabkot: '33',
            filter: [],
            datafilter: [],
            defaultSelectedfilter: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedfilter: '',
            paramselectedfilter: [],
            arraynamafilter: [],

            textfilenya_peta: false,
            tmpidparameter: '',
            selectedradius: '0',
            iduser: JSON.parse(localStorage.getItem("usistem")),
            daftarunduhlayer: [],
            dataunduhlayer: [],
            datajudulunduhlayer: [],
            carikata: '',
            totalkegiatan: 0,
            totalalokasi: 0,
            selectedtahunalokasi: '',
            selectedkabkotalokasi: '',
            jenisbantuan: [],
            datajenisbantuan: [],
            defaultSelectedjenisbantuan: {
                code: 0,
                label: 'Semua Bantuan Keuangan',
                tag: '',
            },
            selectedjenisbantuan: '',

            bidangbantuan: [],
            databidangbantuan: [],
            defaultSelectedbidangbantuan: {
                code: 0,
                label: 'Semua Bidang Bantuan Keuangan',
                tag: '',
            },
            selectedbidangbantuan: '',

            subbidangbantuan: [],
            datasubbidangbantuan: [],
            defaultSelectedsubbidangbantuan: {
                code: 0,
                label: 'Semua Sub Bidang Bantuan Keuangan',
                tag: '',
            },
            selectedsubbidangbantuan: '',
            anggaran: [],
            dataanggaran: [],
            defaultSelectedanggaran: {
                code: 0,
                label: 'Semua Anggaran',
                tag: '',
            },
            selectedanggaran: '',

        };
    },
    methods: {
        async G_tableCSVTabel3(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldataalokasi'), { sheet: "DaftarRiwayatPenanganan" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        parsedatalayer() {
            this.dataunduhlayer = [];
            this.dataunduhlayer = JSON.parse(document.getElementById('detaildatamulti').value);
            //alert(this.dataunduhlayer.length);
            if (this.dataunduhlayer.length > 0) {
                this.datajudulunduhlayer = [];
                for (let i = 0; i < 1; i++) {
                    for (let x = 0; x < this.dataunduhlayer[i].length; x++) {
                        this.datajudulunduhlayer.push(this.dataunduhlayer[i][x].kolom);
                    }
                }
            }
        },
        prosesdata(layer) {
            swal.fire({
                title: "Konfirmasi",
                text: "Untuk data dalam jumlah besar memerlukan waktu loading yang mungkin lama tergantung kondisi internet dan server, Yakin Hendak Memproses Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#15B9D9",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Proses"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.halamanloading = true;
                    this.dataunduhlayer = [];
                    document.getElementById('paramlayerunduh').value = '';
                    document.getElementById('paramlayerunduh').value = layer;
                    document.getElementById("maps").contentWindow.document.getElementById('paramlayerunduh').click();
                    this.halamanloading = false;
                }
            });
            return false;

        },
        tutupmodal() {
            $('#costumModalunduhdata').modal('hide');
        },
        tutupmodalalokasi() {
            $('#costumModalalokasi').modal('hide');
        },
        async cekdataterpilih() {
            this.daftarunduhlayer = [];
            this.dataunduhlayer = [];
            var inputs = document.querySelectorAll("input[type='checkbox']");
            var checkboxesChecked = [];
            for (var i = 0; i < inputs.length; i++) {
                // And stick the checked ones onto an array...
                if (inputs[i].checked) {
                    var temp = inputs[i].id.split("|");
                    checkboxesChecked.push({
                        "id": temp[0],
                        "tipe": temp[12],
                        "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                        "nama": 'Layer ' + temp[4],
                    });
                }
            }
            if (checkboxesChecked.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data layer yang akan diunduh datanya belum dipilih, silahkan pilih dari menu layer peta',
                });
                return false;
            }
            this.daftarunduhlayer = checkboxesChecked;
            $('#costumModalunduhdata').modal('show');
            //alert(JSON.stringify(checkboxesChecked));
        },
        async G_tableCSVTabel1(namefile) {
            try {
                this.halamanloading = true;
                const XLSX = xlsx;
                var wb = XLSX.utils.table_to_book(document.getElementById('customers2'), { sheet: "DataLayerSimfast" });
                XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                this.halamanloading = false;
            } catch (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data masih kosong',
                });
            }
        },
        async G_tableCSVTabel2(namefile) {
            try {
                this.halamanloading = true;
                const XLSX = xlsx;
                var wb = XLSX.utils.table_to_book(document.getElementById('tabeldataadidata'), { sheet: "DataDetailLayerSimfast" });
                XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                this.halamanloading = false;
            } catch (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data masih kosong',
                });
            }
        },
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        onkabkotChange(a) {
            try {
                this.selectedkabkot = this.kabkot[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onkabkotChangeSelect(events) {
            this.selectedkabkot = '';
            var temp = [];
            temp.push(events);
            if (temp[0].length > 0) {
                var tempnol = temp[0];
                this.selectedkabkot = '';
                for (let i = 0; i < tempnol.length; i++) {
                    if (i == 0) {
                        this.selectedkabkot = this.selectedkabkot + tempnol[i].tag;
                    }
                    else {
                        this.selectedkabkot = this.selectedkabkot + ',' + tempnol[i].tag;
                    }
                }
            }
            //alert(this.selectedkabkot);
        },
        onkabkotChangeDeselect(events) {
            this.selectedkabkot = '';
            var temp = [];
            temp.push(events);
            if (temp[0].length > 0) {
                var tempnol = temp[0];
                this.selectedkabkot = '';
                for (let i = 0; i < tempnol.length; i++) {
                    if (i == 0) {
                        this.selectedkabkot = this.selectedkabkot + tempnol[i].tag;
                    }
                    else {
                        this.selectedkabkot = this.selectedkabkot + ',' + tempnol[i].tag;
                    }
                }
            }
            //alert(this.selectedkabkot);
        },
        ceklayer() {
            var cekbox = document.getElementById('paramkodecekbox').value;
            if (document.getElementById(cekbox).checked == true) {
                this.loadpeta();
            }
            else {
                this.loadpeta();
            }
        },
        InisialisasiTree() {
            $.fn.extend({
                treed: function (o) {

                    var openedClass = 'fas fa-minus';
                    var closedClass = 'fas fa-plus';

                    if (typeof o != 'undefined') {
                        if (typeof o.openedClass != 'undefined') {
                            openedClass = o.openedClass;
                        }
                        if (typeof o.closedClass != 'undefined') {
                            closedClass = o.closedClass;
                        }
                    };

                    //initialize each of the top levels
                    var tree = $(this);
                    tree.addClass("tree");
                    tree.find('li').has("ul").each(function () {
                        var branch = $(this); //li with children ul
                        branch.prepend("<i class='indicator glyphicon " + closedClass + "'></i>");
                        branch.addClass('branch');
                        branch.on('click', function (e) {
                            if (this == e.target) {
                                var icon = $(this).children('i:first');
                                icon.toggleClass(openedClass + " " + closedClass);
                                $(this).children().children().toggle();
                            }
                        })
                        branch.children().children().toggle();
                    });
                    //fire event from the dynamically added icon
                    tree.find('.branch .indicator').each(function () {
                        $(this).on('click', function () {
                            $(this).closest('li').click();
                        });
                    });
                    //fire event to open branch if the li contains an anchor instead of text
                    tree.find('.branch>a').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                    //fire event to open branch if the li contains a button instead of text
                    tree.find('.branch>button').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                }
            });
            //Initialization of treeviews
            $('#tree1').treed();
            $('#treelegenda').treed();
            $('.select2').select2();

            //Initialize Select2 Elements
            $('.select2bs4').select2({
                theme: 'bootstrap4'
            });
        },
        kembali() {
            window.location.replace("/");
        },
        closeNavInfo() {
            document.getElementById("myInfoLayer").style.width = "0";
        },
        openNavLayer() {
            this.closeNavPengaturan();
            this.closeNavLegenda();
            if (document.getElementById("mySidenavLayer").style.width == "380px") {
                document.getElementById("mySidenavLayer").style.width = "0";
            } else {
                document.getElementById("mySidenavLayer").style.width = "380px";
            }
        },
        closeNavLayer() {
            document.getElementById("mySidenavLayer").style.width = "0";
        },
        openNavPengaturan() {
            this.closeNavLayer();
            this.closeNavLegenda();
            if (document.getElementById("mySidenavPengaturan").style.width == "380px") {
                document.getElementById("mySidenavPengaturan").style.width = "0";
            } else {
                document.getElementById("mySidenavPengaturan").style.width = "380px";
            }
        },
        closeNavPengaturan() {
            document.getElementById("mySidenavPengaturan").style.width = "0";
        },
        openNavLegenda() {
            this.closeNavPengaturan();
            this.closeNavLayer();
            if (document.getElementById("mySidenavLegenda").style.width == "380px") {
                document.getElementById("mySidenavLegenda").style.width = "0";
            } else {
                document.getElementById("mySidenavLegenda").style.width = "380px";
            }
        },
        closeNavLegenda() {
            document.getElementById("mySidenavLegenda").style.width = "0";
        },
        cetakpeta() {
            document.getElementById("maps").contentWindow.document.getElementById("export-png").click();
        },
        tampilbasemap(tipenya) {
            document.getElementById("maps").contentWindow.document.getElementById(tipenya).click();
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.nama.length <= 2) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nama dengan benar',
                    });
                    return false;
                }
                if ((this.hp.length <= 4) || (typeof parseInt(this.hp) != "number")) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nomor telp dengan benar',
                    });
                    return false;
                }
                if (this.keperluan.length <= 3) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan keperluan dengan benar',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        async ambildata() {
            //alert(this.iduser);
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            this.halamanloading = true;
            var random = Math.random();
            this.data_layer = [];
            await mainAPI2.get("maps_parastapainnovation-LayerPeta?random=" + random + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("tree1").innerHTML = '';
                        this.data_layer = Response.data.content.data;
                        //alert(JSON.stringify(this.data_layer));
                        for (var i = 0; i < this.data_layer.length; i++) {
                            if (this.data_layer[i].id_parent == null) {
                                var iclassbuttonlihat = document.createElement("i");
                                iclassbuttonlihat.classList.add("fas");
                                iclassbuttonlihat.classList.add("fa-list-ul");
                                iclassbuttonlihat.classList.add("text-info");
                                iclassbuttonlihat.title = 'Filter Data';

                                var buttonlihat = document.createElement("BUTTON");
                                buttonlihat.setAttribute("id", 'list' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                buttonlihat.classList.add("btn");
                                buttonlihat.classList.add("btn-tool");
                                buttonlihat.onclick = function () {
                                    var idselect = this.id.replace("list", "select");
                                    if (document.getElementById(idselect).style.display == 'none') {
                                        document.getElementById(idselect).style.display = 'block';
                                    } else {
                                        document.getElementById(idselect).style.display = 'none';
                                    }
                                };
                                buttonlihat.appendChild(iclassbuttonlihat);

                                var selectList = document.createElement("select");
                                selectList.setAttribute("id", 'select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);

                                var cekboxlihat = document.createElement("input");
                                cekboxlihat.type = 'checkbox';
                                cekboxlihat.setAttribute("id", this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                cekboxlihat.onclick = function () {
                                    document.getElementById('paramkodecekbox').value = this.id;
                                    document.getElementById('tombolparamkodecekbox').click();
                                };


                                var iclassbuttonradius = document.createElement("i");
                                iclassbuttonradius.classList.add("fas");
                                iclassbuttonradius.classList.add("fa-arrows-alt-h");
                                iclassbuttonradius.classList.add("text-info");
                                iclassbuttonradius.title = 'Setting Radius (m)';

                                var buttonradius = document.createElement("BUTTON");
                                buttonradius.setAttribute("id", 'listradius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                buttonradius.classList.add("btn");
                                buttonradius.classList.add("btn-tool");
                                buttonradius.onclick = function () {
                                    var idselectradius = this.id.replace("listradius", "radius");
                                    if (document.getElementById(idselectradius).style.display == 'none') {
                                        document.getElementById(idselectradius).style.display = 'block';
                                    } else {
                                        document.getElementById(idselectradius).style.display = 'none';
                                    }
                                };
                                buttonradius.appendChild(iclassbuttonradius);

                                var inputradius = document.createElement("input");
                                inputradius.type = 'number';
                                inputradius.value = this.data_layer[i].radius;
                                inputradius.setAttribute("id", 'radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                if (this.data_layer[i].namajenismenu == 'Layer') {
                                    node.appendChild(cekboxlihat);
                                }
                                node.appendChild(textnode);
                                if (this.data_layer[i].kolomfilter != '') {
                                    node.appendChild(buttonlihat);
                                    node.appendChild(selectList);
                                }
                                if (this.data_layer[i].radius > 0) {
                                    node.appendChild(buttonradius);
                                    node.appendChild(inputradius);
                                }

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById("tree1").appendChild(node);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById("tree1").appendChild(node);
                                    }
                                }

                                if (this.data_layer[i].kolomfilter != '') {
                                    try {
                                        //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                        var x = document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                        //alert(this.data_layer[i].textfilter);
                                        var temparraytextfilter = this.data_layer[i].textfilter.split(",");
                                        if (temparraytextfilter.length > 0) {
                                            var option = document.createElement("option");
                                            option.value = '';
                                            option.text = 'Semua Data';
                                            x.add(option);
                                            for (var array = 0; array < temparraytextfilter.length; array++) {
                                                var option = document.createElement("option");
                                                option.value = temparraytextfilter[array];
                                                option.text = temparraytextfilter[array];
                                                x.add(option);
                                            }
                                        }
                                        x.select2();
                                    } catch (error) {

                                    }
                                }
                                try {
                                    document.getElementById('radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';

                                } catch (error) {

                                }
                                try {
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.fontSize = 'small';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.minWidth = '280px';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.maxWidth = '280px';
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                            else {

                                var iclassbuttonlihat = document.createElement("i");
                                iclassbuttonlihat.classList.add("fas");
                                iclassbuttonlihat.classList.add("fa-list-ul");
                                iclassbuttonlihat.classList.add("text-info");
                                iclassbuttonlihat.title = 'Filter Data';

                                var buttonlihat = document.createElement("BUTTON");
                                buttonlihat.setAttribute("id", 'list' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                buttonlihat.classList.add("btn");
                                buttonlihat.classList.add("btn-tool");
                                buttonlihat.onclick = function () {
                                    var idselect = this.id.replace("list", "select");
                                    if (document.getElementById(idselect).style.display == 'none') {
                                        document.getElementById(idselect).style.display = 'block';
                                    } else {
                                        document.getElementById(idselect).style.display = 'none';
                                    }

                                };
                                buttonlihat.appendChild(iclassbuttonlihat);

                                var selectList = document.createElement("select");
                                selectList.setAttribute("id", 'select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);

                                var iclassbuttonradius = document.createElement("i");
                                iclassbuttonradius.classList.add("fas");
                                iclassbuttonradius.classList.add("fa-arrows-alt-h");
                                iclassbuttonradius.classList.add("text-info");
                                iclassbuttonradius.title = 'Setting Radius (m)';

                                var buttonradius = document.createElement("BUTTON");
                                buttonradius.setAttribute("id", 'listradius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                buttonradius.classList.add("btn");
                                buttonradius.classList.add("btn-tool");
                                buttonradius.onclick = function () {
                                    var idselectradius = this.id.replace("listradius", "radius");
                                    if (document.getElementById(idselectradius).style.display == 'none') {
                                        document.getElementById(idselectradius).style.display = 'block';
                                    } else {
                                        document.getElementById(idselectradius).style.display = 'none';
                                    }
                                };
                                buttonradius.appendChild(iclassbuttonradius);

                                var cekboxlihat = document.createElement("input");
                                cekboxlihat.type = 'checkbox';
                                cekboxlihat.setAttribute("id", this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                cekboxlihat.onclick = function () {
                                    document.getElementById('paramkodecekbox').value = this.id;
                                    document.getElementById('tombolparamkodecekbox').click();
                                };

                                var inputradius = document.createElement("input");
                                inputradius.type = 'number';
                                inputradius.value = this.data_layer[i].radius;
                                inputradius.setAttribute("id", 'radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                if (this.data_layer[i].namajenismenu == 'Layer') {
                                    node.appendChild(cekboxlihat);
                                }

                                if (this.data_layer[i].kolomfilter != '') {
                                    node.appendChild(buttonlihat);
                                    node.appendChild(selectList);
                                }
                                if (this.data_layer[i].radius > 0) {
                                    node.appendChild(buttonradius);
                                    node.appendChild(inputradius);
                                }
                                node.appendChild(textnode);
                                var ul = document.createElement("ul");
                                ul.setAttribute("id", "ul" + this.data_layer[i].id);
                                ul.appendChild(node);
                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                    }
                                }

                                //document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                if (this.data_layer[i].kolomfilter != '') {
                                    try {
                                        //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                        var x = document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                        //alert(this.data_layer[i].textfilter);
                                        var temparraytextfilter = this.data_layer[i].textfilter.split(",");
                                        if (temparraytextfilter.length > 0) {
                                            var option = document.createElement("option");
                                            option.value = '';
                                            option.text = 'Semua Data';
                                            x.add(option);
                                            for (var array = 0; array < temparraytextfilter.length; array++) {
                                                var option = document.createElement("option");
                                                option.value = temparraytextfilter[array];
                                                option.text = temparraytextfilter[array];
                                                x.add(option);
                                            }
                                        }
                                        x.select2();
                                    } catch (error) {

                                    }
                                }
                                try {
                                    document.getElementById('radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';

                                } catch (error) {

                                }
                                try {
                                    //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.fontSize = 'small';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.minWidth = '280px';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.maxWidth = '280px';
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                        }
                        $('#tree1').treed();

                    }
                    else {
                        this.data_layer = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.data_layer = [];
                console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            var random = Math.random();
            this.data_layer = [];
            await mainAPI2.get("maps_parastapainnovation-LayerPeta?random=" + random + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("treelegenda").innerHTML = '';
                        this.data_layer = Response.data.content.data;
                        //alert(JSON.stringify(this.data_layer));
                        for (var i = 0; i < this.data_layer.length; i++) {
                            if (this.data_layer[i].id_parent == null) {

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");

                                node.appendChild(textnode);

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById("treelegenda").appendChild(node);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById("treelegenda").appendChild(node);
                                    }
                                }

                                try {
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                            else {
                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                //alert(this.data_layer[i].id);
                                node.setAttribute("id", this.data_layer[i].id);
                                var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                node.appendChild(textnode);
                                if ((this.data_layer[i].jenis == '2') && (this.data_layer[i].legenda != '')) {
                                    //alert(atob(this.data_layer[i].legenda));
                                    //return;
                                    var arraylegenda = JSON.parse(atob(this.data_layer[i].legenda));
                                    //alert(arraylegenda.length);
                                    
                                    for (var z = 0; z < arraylegenda.length; z++) {
                                        // awal legenda
                                        if ((arraylegenda[z].keterangan == 'gambar') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Point')) {
                                            // awal gambar
                                            var nodelegenda = document.createElement("li");
                                            //node.classList.add("branch");
                                            nodelegenda.setAttribute("id", 'legenda' + this.data_layer[i].id);

                                            var gambar = document.createElement('img');
                                            if (arraylegenda[z].kolom.toString().trim().includes("http")) {
                                                gambar.src = arraylegenda[z].kolom;
                                            }
                                            else {
                                                gambar.src = this.linknya + 'maps_parastapainnovation-Ikon?f=' + arraylegenda[z].kolom;
                                            }
                                            
                                            gambar.style.height = '15px';
                                            //nodelegenda.appendChild(gambar);
                                            var buttonlihat = document.createElement("BUTTON");
                                            buttonlihat.setAttribute("id", 'listlegenda' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                            buttonlihat.classList.add("btn");
                                            buttonlihat.classList.add("btn-tool");
                                            buttonlihat.appendChild(gambar);
                                            nodelegenda.appendChild(buttonlihat);

                                            var textnodelegenda = document.createTextNode(" " + arraylegenda[z].isian + " ");
                                            nodelegenda.appendChild(textnodelegenda);

                                            var ullegenda = document.createElement("ul");
                                            ullegenda.setAttribute("id", "ullegenda" + this.data_layer[i].id);
                                            ullegenda.appendChild(nodelegenda);
                                            node.appendChild(ullegenda);

                                            // akhir gambar
                                        }
                                        else {
                                            // awal bukan gambar
                                            var nodelegenda = document.createElement("li");
                                            //node.classList.add("branch");
                                            nodelegenda.setAttribute("id", 'legenda' + this.data_layer[i].id);
                                            var iclassbuttonlihat = document.createElement("i");
                                            iclassbuttonlihat.classList.add("fas");
                                            if ((arraylegenda[z].keterangan == 'fill') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Polygon') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Radius')) {
                                                iclassbuttonlihat.classList.add("fa-square-full");
                                            }
                                            else {
                                                if (arraylegenda[z].isian.toString().trim().toUpperCase().includes("SUNGAI")) {
                                                    iclassbuttonlihat.classList.add("fa-signature");
                                                }
                                                else {
                                                    iclassbuttonlihat.classList.add("fa-minus");
                                                }

                                            }
                                            //iclassbuttonlihat.classList.add("fa-signature");
                                            //iclassbuttonlihat.classList.add("fa-bacon");
                                            //iclassbuttonlihat.classList.add("fa-square-full");
                                            //iclassbuttonlihat.classList.add("fa-chess-board");
                                            //iclassbuttonlihat.classList.add("fa-border-all");

                                            iclassbuttonlihat.style.color = arraylegenda[z].kolom;
                                            //iclassbuttonlihat.classList.add("text-info");

                                            var buttonlihat = document.createElement("BUTTON");
                                            buttonlihat.setAttribute("id", 'listlegenda' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                            buttonlihat.classList.add("btn");
                                            buttonlihat.classList.add("btn-tool");
                                            buttonlihat.appendChild(iclassbuttonlihat);
                                            nodelegenda.appendChild(buttonlihat);

                                            var textnodelegenda = document.createTextNode(" " + arraylegenda[z].isian + " ");
                                            nodelegenda.appendChild(textnodelegenda);

                                            var ullegenda = document.createElement("ul");
                                            ullegenda.setAttribute("id", "ullegenda" + this.data_layer[i].id);
                                            ullegenda.appendChild(nodelegenda);
                                            node.appendChild(ullegenda);
                                            // akhir bukan gambar
                                        }
                                        // akhir legenda


                                    }
                                }


                                var ul = document.createElement("ul");
                                ul.setAttribute("id", "ul" + this.data_layer[i].id);
                                ul.appendChild(node);
                                //ul.appendChild(ullegenda);

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                    }
                                }

                                try {
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                        }
                        $('#treelegenda').treed();
                    }
                    else {
                        this.data_layer = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.data_layer = [];
                console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI2.get("parastapainnovationreff-GetKabkot?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datakabkot = [];
                        this.kabkot = [];
                        this.datakabkot = Response.data.content.data;
                        this.datakabkot.forEach((item) => {
                            this.kabkot.push({
                                label: item.NAMA,
                                code: this.datakabkot.indexOf(item) + 1,
                                tag: item.KD_KAB,
                            });
                        });
                        this.kabkot.unshift({
                            label: 'Semua Kabupaten/Kota',
                            code: 0,
                            tag: '33',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            if ((this.tampilmodal == null) || (this.tampilmodal == '') || (this.tampilmodal == undefined)) {
                $('#costumModaldisclaimer').modal('show');
            }

            var time = Date.parse(localStorage.getItem("bookstamu"));
            var timeakhir = time + (1 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                $('#costumModaldisclaimer').modal('show');
            }
        },
        async setuju() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                console.log(error);
            });

            this.halamanloading = true;
            const data = {
                tamuparastapa: 'tamuparastapa',
                nama: this.nama,
                hp: this.hp,
                keperluan: this.keperluan,
            };
            const mainAPIVisitor = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPIVisitor.post("parastapainnovatioBukuTamu-IsiTamu", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.halamanloading = false;
                        return false;
                    }
                    else {
                        localStorage.setItem("bookstamu", new Date().toString());
                        $('#costumModaldisclaimer').modal('hide');
                        this.halamanloading = false;
                        //window.location.reload();
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )

        },
        loadpeta() {
            this.halamanloading = true;
            if (this.selectedkabkot == '') {
                this.halamanloading = false;
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Kabupaten / Kota..',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            try {
                var tempceknya = document.getElementById('paramkodecekbox').value;
                var ceknya = document.getElementById(tempceknya).checked;
                try {
                    this.selectedfilter = document.getElementById('select' + tempceknya).value.trim();
                } catch (error) {
                    this.selectedfilter = '';
                }
                try {
                    this.selectedradius = document.getElementById('radius' + tempceknya).value.trim();
                } catch (error) {
                    this.selectedradius = '0';
                }

                var messagetemp = this.linknya + '**' + ceknya + '**' + document.getElementById('paramkodecekbox').value + '**' + this.selectedkabkot + '**' + this.selectedfilter + '**' + this.selectedradius;
            } catch (error) {
                var ceknya = false;
                var messagetemp = this.linknya + '**' + ceknya + '**' + document.getElementById('paramkodecekbox').value + '**' + this.selectedkabkot + '**' + this.selectedfilter + '**' + this.selectedradius;
            }
            //alert(this.selectedfilter);
            const message = messagetemp;
            const iframe = document.getElementById("maps");
            this.sourcenya = '';
            this.sourcenya = '/gis.html';
            iframe.contentWindow.postMessage(message, "*");
            this.halamanloading = false;
        },
        koordinatkosong() {
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Koordinat belum diisi..',
            });
            $('.swal2-container').css("z-index", '999999');
        },
        datakosonglayer() {
            this.halamanloading = false;
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Data Layer ' + document.getElementById('isidatakosong').value + ' Tidak Tersedia..',
            });
            $('.swal2-container').css("z-index", '999999');

        },
        datakosong() {
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Data Layer Gagal Diunduh..',
            });
            $('.swal2-container').css("z-index", '999999');
        },
        openNavInfoBawah() {
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuanj2a098002').innerHTML.split('_');
                this.selectedkabkotalokasi = tempdata[0];
                if (tempdata[1] != "Semua Tahun") {
                    this.selectedtahunalokasi = tempdata[1];
                }
                else {
                    this.selectedtahunalokasi = '';
                }
                this.ambildataalokasi(tempdata[0]);

            } catch (error) {

            }
        },
        openNavInfoBawahKec() {
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuankecj2a098002').innerHTML.split('_');
                this.selectedkabkotalokasi = tempdata[0];
                if (tempdata[1] != "Semua Tahun") {
                    this.selectedtahunalokasi = tempdata[1];
                }
                else {
                    this.selectedtahunalokasi = '';
                }
                this.ambildataalokasi(tempdata[0]);

            } catch (error) {

            }
        },
        openNavInfoBawahDesa() {
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuandesaj2a098002').innerHTML.split('_');
                this.selectedkabkotalokasi = tempdata[0];
                if (tempdata[1] != "Semua Tahun") {
                    this.selectedtahunalokasi = tempdata[1];
                }
                else {
                    this.selectedtahunalokasi = '';
                }
                this.ambildataalokasi(tempdata[0]);

            } catch (error) {

            }
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.JustClearlocalStorage();
            }
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
            this.halamanloading = true;
            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationreff-GetKabkot?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datakabkot = [];
                        this.kabkot = [];
                        this.datakabkot = Response.data.content.data;
                        this.datakabkot.forEach((item) => {
                            this.kabkot.push({
                                label: item.NAMA,
                                code: this.datakabkot.indexOf(item) + 1,
                                tag: item.KD_KAB,
                            });
                        });
                        this.kabkot.unshift({
                            label: 'Semua Kabupaten/Kota',
                            code: 0,
                            tag: '33',
                        });
                    }
                    else {
                        this.datakabkot = [];
                        this.kabkot = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datakabkot = [];
                this.kabkot = [];
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreff-GetTahunRiwayatPenanganan?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahun = [];
                        this.tahun = [];
                        this.datatahun = Response.data.content.data;
                        this.datatahun.forEach((item) => {
                            this.tahun.push({
                                label: item.tahun,
                                code: this.datatahun.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        this.tahun.unshift({
                            label: 'Semua Tahun',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datatahun = [];
                        this.tahun = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datatahun = [];
                this.tahun = [];
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreff-GetJenisBantuan?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenisbantuan = [];
                        this.jenisbantuan = [];
                        this.datajenisbantuan = Response.data.content.data;
                        this.datajenisbantuan.forEach((item) => {
                            this.jenisbantuan.push({
                                label: item.nama,
                                code: this.datajenisbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.jenisbantuan.unshift({
                            label: 'Semua Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datajenisbantuan = [];
                        this.jenisbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datajenisbantuan = [];
                this.jenisbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreffbantuan-GetBidangBantuan?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.databidangbantuan = [];
                        this.bidangbantuan = [];
                        this.databidangbantuan = Response.data.content.data;
                        this.databidangbantuan.forEach((item) => {
                            this.bidangbantuan.push({
                                label: item.nama,
                                code: this.databidangbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.bidangbantuan.unshift({
                            label: 'Semua Bidang Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.databidangbantuan = [];
                        this.bidangbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.databidangbantuan = [];
                this.bidangbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreffbantuan-GetSubBidangBantuan?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubbidangbantuan = [];
                        this.subbidangbantuan = [];
                        this.datasubbidangbantuan = Response.data.content.data;
                        this.datasubbidangbantuan.forEach((item) => {
                            this.subbidangbantuan.push({
                                label: item.nama,
                                code: this.datasubbidangbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.subbidangbantuan.unshift({
                            label: 'Semua Sub Bidang Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datasubbidangbantuan = [];
                        this.subbidangbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datasubbidangbantuan = [];
                this.subbidangbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreff-GetJenisAnggaran?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataanggaran = [];
                        this.anggaran = [];
                        this.dataanggaran = Response.data.content.data;
                        this.dataanggaran.forEach((item) => {
                            this.anggaran.push({
                                label: item.nama,
                                code: this.dataanggaran.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.anggaran.unshift({
                            label: 'Semua Anggaran',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.dataanggaran = [];
                        this.anggaran = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.dataanggaran = [];
                this.anggaran = [];
                //console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildatabidangterpilih() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
            this.halamanloading = true;
            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationreffbantuan-GetBidangBantuan?random=" + random + "&jenisbantuan=" + this.selectedjenisbantuan).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.databidangbantuan = [];
                        this.bidangbantuan = [];
                        this.databidangbantuan = Response.data.content.data;
                        this.databidangbantuan.forEach((item) => {
                            this.bidangbantuan.push({
                                label: item.nama,
                                code: this.databidangbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.bidangbantuan.unshift({
                            label: 'Semua Bidang Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.databidangbantuan = [];
                        this.bidangbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.databidangbantuan = [];
                this.bidangbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildatasubbidangterpilih() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
            this.halamanloading = true;
            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationreffbantuan-GetSubBidangBantuan?random=" + random + "&jenisbantuan=" + this.selectedjenisbantuan + "&bidangbantuan=" + this.selectedbidangbantuan).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubbidangbantuan = [];
                        this.subbidangbantuan = [];
                        this.datasubbidangbantuan = Response.data.content.data;
                        this.datasubbidangbantuan.forEach((item) => {
                            this.subbidangbantuan.push({
                                label: item.nama,
                                code: this.datasubbidangbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.subbidangbantuan.unshift({
                            label: 'Semua Sub Bidang Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datasubbidangbantuan = [];
                        this.subbidangbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datasubbidangbantuan = [];
                this.subbidangbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildataalokasi(kodelokasi) {
            if (kodelokasi.length == 4) {
                this.halamanloading = true;

                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    },
                });
                var random = Math.random();

                await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.ipnya = Response.data.randkey;
                        }
                        else {
                            this.ipnya = '';
                        }
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    this.datapesan = [];
                    //console.log(error);
                });

                const mainAPI2 = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    },
                });
                var random = Math.random();
                await mainAPI2.get("parastapainnovationriwayat-DataRiwayat?random=" + random + "&tahun=" + this.selectedtahunalokasi
                    + "&kabkot=" + this.selectedkabkotalokasi + "&anggaran=" + this.selectedanggaran + "&jenisbantuan=" + this.selectedjenisbantuan
                    + "&bidangbantuan=" + this.selectedbidangbantuan + "&subbidangbantuan=" + this.selectedsubbidangbantuan
                ).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.totalalokasi = 0;
                            this.datamaster = [];
                            this.datamaster = Response.data.content.data;
                            this.totalalokasi = Response.data.content.totalalokasi;
                            $('#costumModalalokasi').modal('show');
                            this.halamanloading = false;
                        }
                        else {
                            this.datamaster = [];
                            this.totalalokasi = 0;
                            this.halamanloading = false;
                        }

                    }
                ).catch(error => {
                    this.datapesan = '';
                    this.datamaster = [];
                    this.totalalokasi = 0;
                    //console.log(error);
                    this.halamanloading = false;
                });
            }
            else if (kodelokasi.length == 6) {
                this.halamanloading = true;

                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    },
                });
                var random = Math.random();

                await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.ipnya = Response.data.randkey;
                        }
                        else {
                            this.ipnya = '';
                        }
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    this.datapesan = [];
                    //console.log(error);
                });

                const mainAPI2 = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    },
                });
                var random = Math.random();
                await mainAPI2.get("parastapainnovationriwayatkec-DataRiwayatKec?random=" + random + "&tahun=" + this.selectedtahunalokasi
                    + "&kecamatan=" + this.selectedkabkotalokasi + "&anggaran=" + this.selectedanggaran + "&jenisbantuan=" + this.selectedjenisbantuan
                    + "&bidangbantuan=" + this.selectedbidangbantuan + "&subbidangbantuan=" + this.selectedsubbidangbantuan
                ).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.totalalokasi = 0;
                            this.datamaster = [];
                            this.datamaster = Response.data.content.data;
                            this.totalalokasi = Response.data.content.totalalokasi;
                            $('#costumModalalokasi').modal('show');
                            this.halamanloading = false;
                        }
                        else {
                            this.datamaster = [];
                            this.totalalokasi = 0;
                            this.halamanloading = false;
                        }

                    }
                ).catch(error => {
                    this.datapesan = '';
                    this.datamaster = [];
                    this.totalalokasi = 0;
                    //console.log(error);
                    this.halamanloading = false;
                });
            }
            else {
                this.halamanloading = true;

                const mainAPI = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    },
                });
                var random = Math.random();

                await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.ipnya = Response.data.randkey;
                        }
                        else {
                            this.ipnya = '';
                        }
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    this.datapesan = [];
                    //console.log(error);
                });

                const mainAPI2 = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    },
                });
                var random = Math.random();
                await mainAPI2.get("parastapainnovationriwayatdesa-DataRiwayatDesa?random=" + random + "&tahun=" + this.selectedtahunalokasi
                    + "&desa=" + this.selectedkabkotalokasi + "&anggaran=" + this.selectedanggaran + "&jenisbantuan=" + this.selectedjenisbantuan
                    + "&bidangbantuan=" + this.selectedbidangbantuan + "&subbidangbantuan=" + this.selectedsubbidangbantuan
                ).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        if (this.datapesan == 'data diketemukan') {
                            this.totalalokasi = 0;
                            this.datamaster = [];
                            this.datamaster = Response.data.content.data;
                            this.totalalokasi = Response.data.content.totalalokasi;
                            $('#costumModalalokasi').modal('show');
                            this.halamanloading = false;
                        }
                        else {
                            this.datamaster = [];
                            this.totalalokasi = 0;
                            this.halamanloading = false;
                        }

                    }
                ).catch(error => {
                    this.datapesan = '';
                    this.datamaster = [];
                    this.totalalokasi = 0;
                    //console.log(error);
                    this.halamanloading = false;
                });
            }


        },
        onanggaranChange(a) {
            try {
                this.selectedanggaran = this.anggaran[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onjenisbantuanChange(a) {
            try {
                this.selectedjenisbantuan = this.jenisbantuan[a].tag;
            }
            catch (err) {
                return;
            }
            this.defaultSelectedbidangbantuan = {
                code: 0,
                label: 'Semua Bidang Bantuan Keuangan',
                tag: '',
            };
            this.selectedsubbidangbantuan = '';
            this.ambildatabidangterpilih();
            this.defaultSelectedsubbidangbantuan = {
                code: 0,
                label: 'Semua Sub Bidang Bantuan Keuangan',
                tag: '',
            };
            this.selectedsubbidangbantuan = '';
            this.ambildatasubbidangterpilih();

        },
        onbidangbantuanChange(a) {
            try {
                this.selectedbidangbantuan = this.bidangbantuan[a].tag;
            }
            catch (err) {
                return;
            }
            this.selectedsubbidangbantuan = '';
            this.defaultSelectedsubbidangbantuan = {
                code: 0,
                label: 'Semua Sub Bidang Bantuan Keuangan',
                tag: '',
            };
            this.selectedsubbidangbantuan = '';
            this.ambildatasubbidangterpilih();
        },
        onsubbidangbantuanChange(a) {
            try {
                this.selectedsubbidangbantuan = this.subbidangbantuan[a].tag;
            }
            catch (err) {
                return;
            }
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildatareff();
        this.ambildata();
        this.InisialisasiTree();
        window.addEventListener('keydown', function (event) {
            if (event.code == 'KeyZ' && (event.ctrlKey || event.metaKey)) {
                localStorage.setItem("bookstamu", new Date().toString());
                $('#costumModaldisclaimer').modal('hide');
            }
        });
    },
}
</script>

<style></style>